import { GameServices } from '../../services/game-services';
import { BlocksAssetType } from '../../model/blocks-types';
import { Block } from 'src/games/phaserblocks/logic/models/block';
import { Shape } from 'src/games/phaserblocks/logic/models/shape';
import { BehaviorSubject } from 'rxjs';

export class BlockViewModel {
  public get onGameSetupStartTrigger() {
    return this.gameServices.gameRunnerService.onGameSetupStartTrigger;
  }
  public get asset() {
    return this.gameServices.assetCatalogueService.getAsset(this._blockAssetType);
  }
  public get highlightedAsset() {
    return this.gameServices.assetCatalogueService.getAsset(this._blockHighlightedAssetType);
  }
  public get layoutConfig() {
    return this.gameServices.gameMetricsService.gameLayoutConfig;
  }
  public get isHighlighted$() {
    return this.isHighlighted.asObservable();
  }
  public get isValid$() {
    return this.isValid.asObservable();
  }
  public get block() {
    return this._block;
  }
  public get shapeIndex() {
    return this._shapeIndex;
  }
  public get uniqueCellsX() {
    return this._shape.blocks.reduce((max, block) => {
      return Math.max(max, block.posInShape.col + 1);
    }, 0);
  }
  public get uniqueCellsY() {
    return this._shape.blocks.reduce((max, block) => {
      return Math.max(max, block.posInShape.row + 1);
    }, 0);
  }

  private readonly isHighlighted = new BehaviorSubject<boolean>(false);
  private readonly isValid = new BehaviorSubject<boolean>(true);
  private readonly _block: Block;
  private readonly _shape: Shape;
  private readonly _shapeIndex: number;
  private readonly _blockAssetType: BlocksAssetType;
  private readonly _blockHighlightedAssetType: BlocksAssetType;

  constructor(
    private gameServices: GameServices,
    block: Block,
    shape: Shape,
    shapeIndex: number,
  ) {
    this._block = block;
    this._shape = shape;
    this._shapeIndex = shapeIndex;
    this._blockAssetType =
      block.multiplier > 0 ? BlocksAssetType.BlockMultiplier : BlocksAssetType.BlockNormal;
    this._blockHighlightedAssetType =
      block.multiplier > 0
        ? BlocksAssetType.BlockMultiplierHighlight
        : BlocksAssetType.BlockNormalHighlight;
  }

  public highlightBlock(highlight: boolean) {
    this.isHighlighted.next(highlight);
  }

  public setValid(isValid: boolean) {
    this.isValid.next(isValid);
  }
}
